import {retainConstants} from '_constants';

const INITIAL_STATE = {
    retainCampaigns:  {},
    loadingRetainCampaign: false,
    retainCampaignError: '',

    retainMetrics: {},
    loadingRetainMetrics: false,
    retainMetricsError: '',

    singleRetainMetrics: {},
    loadingSingleRetainMetrics: false,
    singleRetainMetricsError: '',

    attributionMetrics: {},
    loadingAttributionMetrics: false,
    attributionMetricsError: '',
};

export function retainReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_REQUEST:
            return {...state, loadingRetainCampaign: true, retainCampaignError: ''};
        case retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_SUCCESS:
            return {...state, retainCampaigns: action.payload, loadingRetainCampaign: false};
        case retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_FAILURE:
            return {...state, retainCampaignError: action.error, loadingRetainCampaign: false};

        case retainConstants.GET_COMPANY_RETAIN_METRICS_REQUEST:
            return {...state, loadingRetainMetrics: true, retainMetricsError: ''};
        case retainConstants.GET_COMPANY_RETAIN_METRICS_SUCCESS:
            return {...state, retainMetrics: action.payload, loadingRetainMetrics: false};
        case retainConstants.GET_COMPANY_RETAIN_METRICS_FAILURE:
            return {...state, retainMetricsError: action.error, loadingRetainMetrics: false};

        case retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_REQUEST:
            return {...state, loadingRetainCampaign: true, retainCampaignError: ''};
        case retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_SUCCESS:
            return {...state, retainCampaigns: action.payload, loadingRetainCampaign: false};
        case retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_FAILURE:
            return {...state, retainCampaignError: action.error, loadingRetainCampaign: false};
        
        case retainConstants.GET_ORGANIZATION_RETAIN_METRICS_REQUEST:
            return {...state, loadingRetainMetrics: true, retainMetricsError: ''};
        case retainConstants.GET_ORGANIZATION_RETAIN_METRICS_SUCCESS:
            return {...state, retainMetrics: action.payload, loadingRetainMetrics: false};
        case retainConstants.GET_ORGANIZATION_RETAIN_METRICS_FAILURE:
            return {...state, retainMetricsError: action.error, loadingRetainMetrics: false};

        case retainConstants.GET_SINGLE_RETAIN_CAMPAIGN_METRICS_REQUEST:
            return {...state, loadingSingleRetainMetrics: true, singleRetainMetricsError: ''};
        case retainConstants.GET_SINGLE_RETAIN_CAMPAIGN_METRICS_SUCCESS:
            return {...state, singleRetainMetrics: action.payload, loadingSingleRetainMetrics: false};
        case retainConstants.GET_SINGLE_RETAIN_CAMPAIGN_METRICS_FAILURE:
            return {...state, singleRetainMetricsError: action.error, loadingSingleRetainMetrics: false};

        case retainConstants.GET_CAMPAIGN_ATTRIBUTION_METRICS_REQUEST:
            return {...state, loadingAttributionMetrics: true, attributionMetricsError: ''};
        case retainConstants.GET_CAMPAIGN_ATTRIBUTION_METRICS_SUCCESS:
            return {...state, attributionMetrics: action.payload, loadingAttributionMetrics: false};
        case retainConstants.GET_CAMPAIGN_ATTRIBUTION_METRICS_FAILURE:
            return {...state, attributionMetricsError: action.error, loadingAttributionMetrics: false};

        default:
            return state
    }
}
